import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('VoxPop ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          gap: 16,
          padding: 24,
          textAlign: 'center',
        }}>
          <span style={{ fontSize: 56 }}>🎬</span>
          <h2 style={{
            fontFamily: 'var(--font-display)',
            fontSize: 40,
            textTransform: 'uppercase',
            color: 'var(--red)',
          }}>
            Scene Missing
          </h2>
          <p style={{ color: 'var(--gray)', fontSize: 16, maxWidth: 400, lineHeight: 1.6 }}>
            Something went wrong on this page. This happens sometimes — even the best productions have
            blooper reels.
          </p>
          {this.state.error && (
            <pre style={{
              background: 'var(--surface)',
              border: '1px solid var(--border)',
              borderRadius: 8,
              padding: '12px 16px',
              fontSize: 12,
              color: 'var(--gray)',
              maxWidth: 600,
              overflow: 'auto',
              textAlign: 'left',
            }}>
              {this.state.error.message}
            </pre>
          )}
          <button
            className="btn btn-magenta"
            onClick={() => this.setState({ hasError: false, error: null })}
          >
            Try Again
          </button>
          <a href="/" className="btn btn-ghost" style={{ fontSize: 14 }}>← Back to Home</a>
        </div>
      );
    }
    return this.props.children;
  }
}
export default ErrorBoundary;
